module.exports = __webpack_public_path__ + "img/photo-cheerful-chauffeur-smiling-at-camera.8acf2295.png";